import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { useWorkflow, Workflow } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<Workflow>
      useData={useWorkflow}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
